import React, { useCallback, useEffect, useState } from "react";
import IndustryScripHeader from "../../../components/import/industryScrip/IndustryScripHeader.jsx";
import Breadcrumbs from "../../../components/ui/Breadcrumbs.jsx";
import IndustryScripConfig from "./IndustryScripConfig.jsx";
import axios from "axios";
import { errorNotify, successNotify } from "../../../Services/Notification.js";
import RadioButton from "../../../components/ui/RadioButton.jsx";
import { format } from "date-fns";

const getIndustryScripDataAPIURL = `${process.env.REACT_APP_API_URL}api/service-tracker/scrip-industry/`;
const reloadAPIURL = `${process.env.REACT_APP_API_URL}api/import-scrip-industry/`;
const IndustryScrip = () => {
  const [renderKey, setRenderKey] = useState(0);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState();

  const triggerRerender = () => {
    setRenderKey((prev) => prev + 1);
  };
  // API CONFIG
  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("subscriberToken")
      ? sessionStorage.getItem("subscriberToken")
      : sessionStorage.getItem("token")
      }`,
    "Content-Type": "application/json",
  };

  const getIndustryScripData = async () => {
    setLoading(true);
    try {
      if (filter?.bookclose_recorddate && filter?.nse_exdate) {
        const payload = {
          start_date: filter?.bookclose_recorddate,
          end_date: filter?.nse_exdate,
        };
        const res = await axios.post(getIndustryScripDataAPIURL, payload, {
          headers,
        });

        if (!res.data.error) {
          const flattened = res.data.data
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .flatMap(({ date, day, bod, eod }) => {
              // Helper to tag real entries
              const tagEntries = (arr, type) =>
                arr.map((entry) => ({
                  id: entry?.id ?? "",
                  service_name: entry?.service_name,
                  date: date,
                  day,
                  start_time: entry?.start_time ?? "",
                  end_time: entry?.end_time ?? "",
                  file_name: entry?.file_name ?? "",
                  operation_status: entry?.operation_status ?? "",
                  ip_cnt: entry?.ip_cnt ?? 0,
                  op_cnt: entry?.op_cnt ?? 0,
                  file_type: type,
                }));

              const placeholder = (type) => ({
                id: "",
                service_name: "",
                date: date,
                day,
                start_time: "",
                end_time: "",
                file_name: "",
                operation_status: "",
                ip_cnt: 0,
                op_cnt: 0,
                file_type: type,
              });

              const bodEntries =
                bod?.length > 0 ? tagEntries(bod, "bod") : [placeholder("bod")];

              const eodEntries =
                eod?.length > 0 ? tagEntries(eod, "eod") : [placeholder("eod")];

              return [...bodEntries, ...eodEntries];
            });

          setData(flattened);

          setLoading(false);
        } else {
          errorNotify(res.data.message);
          setLoading(false);
        }
      } else if (filter?.bookclose_recorddate && !filter?.nse_exdate) {
        errorNotify("Please select end date");
      } else if (!filter?.bookclose_recorddate && filter?.nse_exdate) {
        errorNotify("Please select start date");
      } else if (!filter?.bookclose_recorddate && !filter?.nse_exdate) {
        errorNotify("Please select start and end date");
      }
      setLoading(false);
    } catch (err) {
      errorNotify("Something went wrong");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filter?.bookclose_recorddate || filter?.nse_exdate) {
      getIndustryScripData();
    } else if (!filter) {
      setData([]);
    }
  }, [filter?.bookclose_recorddate, filter?.nse_exdate, renderKey]);

  const handleReload = async (date, fileType) => {
    try {
      if (date) {
        const payload = {
          start_date: date,
          end_date: date,
          dag_time: fileType,
        };
        const res = await axios.post(reloadAPIURL, payload, { headers });
        if (res.data.result[0][date] === "DATA_INSERTED") {
          successNotify(res.data.result[0][date]?.split("_").join(" "));
          triggerRerender();
          return true;
        } else {
          errorNotify(res.data.result[0][date]?.split("_").join(" "));
          return true;
        }
      }
    } catch (err) {
      errorNotify("Something went wrong");
      triggerRerender();
      return true;
    }
  };

  const buttonConfig = {
    handleReload: handleReload,
  };

  const breadcrumbs = ["Home", "Import", "Scrip & Industry"];

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />

      <IndustryScripHeader setFilter={setFilter} />
      <IndustryScripConfig
        tableData={data}
        buttonConfig={buttonConfig}
        loading={loading}
      />
    </div>
  );
};

export default IndustryScrip;
